export default __webpack_public_path__ + "static/media/bg_orange_04.ca9d51f1.png";